import React from "react";
import ReactDOM from "react-dom";
import Home from "./home/home";
import './index.css';
import './normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import nl from 'react-intl/locale-data/nl';
import localeData from './locales/data.json';

addLocaleData([...en, ...nl]);

const language = (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage;
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
const messages = localeData[languageWithoutRegionCode] || localeData[language] || localeData.en;

ReactDOM.render(
  <IntlProvider locale={language} messages={messages}>
    <Home />
  </IntlProvider >,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js